
import {
  I_VALIDATION,
  T_FORM_ERRORS,
} from './types'

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//const URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

const validation: I_VALIDATION = (form, t) => {
  const errors: T_FORM_ERRORS = {}

  Object.keys(form).map(fieldName => {
    const value = form[fieldName]

    switch (fieldName) {
      case 'name':
        if (!value) {
          errors.name = t('errors_name_required')
        }
        break
      case 'site':
        /* if (value && !URL_REGEX.test(value)) {
          errors.site = t('errors_site_incorrect')
        } */
        break
      case 'email':
        if (!EMAIL_REGEX.test(value)) {
          errors.email = t('errors_email_incorrect')
        }
        if (!value) {
          errors.email = t('errors_email_required')
        }
        break
      case 'message':
        if (value.length > 1024) {
          errors.message = t('errors_message_max').replace('$1', '1024')
        }
        break
      case 'agree':
        if (!value) {
          errors.agree = t('errors_agree_required')
        }
    }
  })

  return errors
}

export default validation